<template>
    <MenuItem class="themeable" v-if="display" @click.native="goToLink(item.Url)" :key="item.Id" :name="item.ElementId" :data-niame="item.Id">
    <!-- <i class="ivu-icon" :class="item.Icon"  style="font-family:iconfont"></i> -->
            <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#' + item.Icon"></use>
            </svg>
    </MenuItem>
    <Submenu v-else-if="item.childs&&item.childs.length>0&&item.Level<2" :key="item.Id" :name="item.ElementId">
        <template slot="title">
            <!-- <i class="ivu-icon" :class="item.Icon" style="font-family:iconfont"></i> -->
            <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#' + item.Icon"></use>
            </svg>
            <span>{{ item.Name }}</span>
        </template>
        <MenuChildItem  v-for="data in item.childs" :item="data" :key="data.Id"></MenuChildItem>
    </Submenu>
    <MenuItem v-else @click.native="goToLink(item.Url)" :key="item.Id" :name="item.ElementId" :data-niame="item.Id">
    <!-- <i class="ivu-icon" :class="item.Icon"  style="font-family:iconfont"></i> -->
            <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#' + item.Icon"></use>
            </svg>
    <span>{{ item.Name }}</span>
    </MenuItem>
</template>

<script>
export default {
    props: {
        item: Object,
        display:Boolean,
    },
    data() {
        return {

        }
    },
    methods: {
        goToLink(url) {
            this.$router.push(url);
        }
    }
}
</script>

<style lang="scss" scoped>

.ivu-menu-vertical .ivu-menu-item-active,
.ivu-menu-vertical .ivu-menu-item-selected {
    background: #444444 !important;
}

.ivu-menu-vertical .ivu-menu-submenu {
    color: #fff;
    overflow: hidden;
}
.ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title{
    padding: 12px 16px;
    overflow: hidden;
}
.ivu-menu-vertical .ivu-menu .ivu-menu-item {
    height: 40px;
    padding: 0;
    line-height: 40px;
    color: #9FA1A4;
    background: #191919;
    padding-left: 15px !important;
}

.ivu-menu-vertical .ivu-menu .ivu-menu-item-active,
.ivu-menu-vertical .ivu-menu .ivu-menu-item-selected {
    background: #282b35 !important;
    color: #ff5858;
}
.ivu-menu-vertical .ivu-menu .ivu-menu-item:hover{
    background: #282b35 !important;
    color: #ff5858;
}
.ivu-menu-vertical.ivu-menu-light:after {
    width: 0;
}

.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    left: 0;
    width: 4px;
}


</style>



// WEBPACK FOOTER //
// src/components/aside/childItem.vue